import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { useNavigate } from "@tanstack/react-router";

import { useBulkUpdateRoutesMutation } from "@/hooks/routes";
import { useCurrentClimbType, useCurrentVenueUuid } from "@/hooks/venues";

import { useModal } from "./useModal";

export default function RestoreArchiveRoutes({ routeUuids }: { routeUuids: string[] }) {
  const { close } = useModal();
  const venueUuid = useCurrentVenueUuid();
  const climbType = useCurrentClimbType();
  const mutation = useBulkUpdateRoutesMutation();
  const onConfirm = () => {
    if (!venueUuid || !climbType) return;
    mutation.mutate(
      routeUuids.map((uuid) => ({
        uuid,
        endTime: null,
      })),
      {
        onSuccess: () => {
          close();
          navigate({
            to: "/gym/$venueUuid/routes/$climbType",
            params: { venueUuid, climbType },
            search: { recentlyRestored: true },
          });
        },
        onError: () => {
          alert("Failed to restore routes. Please try again or contact support");
        },
      },
    );
  };

  const navigate = useNavigate();

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          {routeUuids.length === 1 ? "1 route" : `${routeUuids.length} routes`} will be restored
          from the archive.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="danger"
          onClick={() => {
            onConfirm();
          }}
          sx={{ flex: 1 }}
          loading={mutation.isPending}
          loadingPosition="start"
          disabled={mutation.isPending}
        >
          Restore
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
